module.exports = __webpack_public_path__ + "assets/img/e2ebbb4e718418cc9dd8ebb8d4d184a0.svg";